module.exports = __webpack_public_path__ + "static/media/mockup-ns.7e7ea030.png";